module.exports = __webpack_public_path__ + "img/logo-icon.1866f416.png";